unit Constants;

interface

type
  TGesloNacin = (gnRegistracija, gnPozabilGeslo, gnMenjavaGesla);


implementation

end.
